import { Injectable } from '@angular/core';
import { User, UserService } from './user.service';
import { NavigationService } from './navigation.service';
import { OnboardingService } from './onboarding.service';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { evLog, LoginParams } from '../../shared/utils/login-utils';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor(
    private readonly userService: UserService,
    private readonly router: Router,
    private readonly navigationService: NavigationService,
    private readonly onboardingService: OnboardingService
  ) {}

  public async login(params: LoginParams, user: User, returnUrl?: string) {
    evLog('login: ', { params, returnUrl });

    const isAuthenticated = this.userService.isAuthenticated();
    const isisAuthenticatedNeedsVerify = this.userService.isAuthenticatedNeedsVerify();
    const twoFactorNeeded = user.twoFactorNeeded;

    evLog('login: ', {
      isAuthenticated,
      isisAuthenticatedNeedsVerify,
      twoFactorNeeded
    });

    if (this.userService.isAuthenticatedNeedsVerify()) {
      if (twoFactorNeeded.type === 'TWO_FACTOR_SMS') {
        return this.navigationService.goToVerifyMobileNumber();
      } else {
        return this.navigationService.goToVerifyAuthCode();
      }
    }

    if (this.userService.isAuthenticated() && !user.mobileVerified) {
      return this.router.navigateByUrl('/signup').then();
    }

    if (this.userService.isAuthenticated() && user.mobileVerified) {
      // clients who have not finished the signup wizard resume it instead of entering the app
      try {
        const status = await this.onboardingService.getStatus().pipe(take(1)).toPromise();
        if (status && !status.completed) {
          return this.router.navigateByUrl('/signup').then();
        }
      } catch (e) {
        // if the status check fails, fall through to the normal destination
        console.error('Onboarding status check failed:', e);
      }

      if (returnUrl) {
        return this.router.navigateByUrl(returnUrl);
      } else {
        await this.navigationService.goToDashboard();
      }
    }
  }
}
